var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.11 25.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.29,12.42l8.82,6.77-3.83,.64,2.38,4.86-1.98,.96-2.4-4.89-2.99,2.59V12.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.87,22.45H2.03c-.16,0-.29-.13-.29-.29V6.99c0-.16,.13-.29,.29-.29H18.95c.16,0,.29,.13,.29,.29V15.14l1.75,1.32V5.24c0-.16-.13-.29-.29-.29H.29c-.16,0-.29,.13-.29,.29V23.91c0,.16,.13,.29,.29,.29H11.87v-1.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.23,0H6.76s-.06,0-.09,.02l-1.44,.72c-.07,.03-.11,.1-.11,.18v3.33c0,.11,.09,.2,.2,.2h1.19c.11,0,.2-.09,.2-.2V1.79c0-.11,.09-.2,.2-.2h7.16c.11,0,.2,.09,.2,.2v2.46c0,.11,.09,.2,.2,.2h1.19c.11,0,.2-.09,.2-.2V.92c0-.08-.04-.14-.11-.18L14.31,.02s-.06-.02-.09-.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.da4b0ec459dc4157ff3245c2fd7f8d4c.svg";
export { ForwardRef as ReactComponent };